import { AccountService } from "src/app/services/account.service";
import { SignalRService } from "./../../services/signalr.service";
import { ApiService } from "src/app/services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CompanyNews } from "src/app/models/company-news";
import { NewsDetailsModalComponent } from "../news-details-modal/news-details-modal.component";

@Component({
  selector: "app-market-news",
  templateUrl: "./market-news.component.html",
  styleUrls: ["./market-news.component.scss"],
})
export class MarketNewsComponent implements OnInit {
  isMarketNewsLoading: boolean;
  companyNews: CompanyNews[];

  isNewsView = true;
  announcements: CompanyNews[];
  isMarket: boolean;

  setNewsView(value) {
    this.isNewsView = value;
  }
  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    private _service: ApiService,
    signalService: SignalRService,
    private accService: AccountService
  ) {
    signalService.newsChanges.subscribe((res: any) => {
      res.forEach((element: CompanyNews) => {
        switch (element.TYPE) {
          case 1:
            this.companyNews?.unshift(element);
          default:
            this.announcements?.unshift(element);
        }
        // this.companyNews = res.filter((book) => book.TYPE === 1);
        // this.announcements = res.filter((book) => book.TYPE != 1);
      });
    });

    this.accService.isFullMarketUser.subscribe((isMarket) => {
      this.isMarket = isMarket;
    });
  }

  ngOnInit() {
    this.companyNews = [];
    this.fetchTodayNews();
  }

  openNewsModal(item) {
    this.dialog.open(NewsDetailsModalComponent, {
      panelClass: "news-details-modal",
      data: {
        item,
      },
    });
  }

  fetchTodayNews() {
    this.isMarketNewsLoading = true;

    this._service.fetchMarketNews().subscribe((res) => {
      this.isMarketNewsLoading = false;

      if (res) {
        this.companyNews = res.filter((book) => book.TYPE == 1);
        this.announcements = res.filter((book) => book.TYPE != 1);
      }
    });
  }

  getColor(item) {
    switch (item) {
      case 1:
        return {
          background: "aquamarine",
          color: "black",
        };
      case 2:
        return {
          background: "bisque",
          color: "black",
        };
      case 3:
        return {
          background: "teal",
          color: "whitesmoke",
        };
      case 4:
        return {
          background: "greenyellow",
          color: "black",
        };
      case 5:
        return {
          background: "cornflowerblue",
          color: "black",
        };
      case 6:
        return {
          background: "darkorange",
          color: "black",
        };
      case 7:
        return {
          background: "darkslategrey",
          color: "white",
        };
      case 8:
        return {
          background: "yellow",
          color: "black",
        };
      case 9:
        return {
          background: "violet",
          color: "white",
        };
      case 12: {
        return {
          background: "lightcoral",
          color: "whitesmoke",
        };
      }
      default: {
        return {
          background: "lightgray",
          color: "black",
        };
      }
    }
  }
}
